import { addIcons } from 'ionicons';
import {
    send, informationOutline, attachOutline, closeOutline, peopleOutline, imagesOutline, documentsOutline, calendarClearOutline, documentTextOutline, ellipsisVerticalCircleOutline, ellipsisVerticalOutline, personCircle, newspaperSharp, downloadOutline, shareOutline, ellipsisHorizontalCircleOutline, chevronDownCircleOutline, menuOutline, copyOutline, trashOutline, logOutOutline, phonePortraitOutline, timeOutline, mailOutline, personOutline, eye, eyeOutline, eyeOffOutline, arrowDownOutline, locationOutline
} from 'ionicons/icons';

export function registerIcons() {
    addIcons({send, informationOutline, attachOutline, closeOutline, peopleOutline,
        imagesOutline, documentsOutline, calendarClearOutline, documentTextOutline,
        ellipsisVerticalCircleOutline, ellipsisVerticalOutline, personCircle, newspaperSharp,
        downloadOutline, shareOutline, ellipsisHorizontalCircleOutline, chevronDownCircleOutline,
        menuOutline, copyOutline, trashOutline, logOutOutline, phonePortraitOutline,
        timeOutline, mailOutline, personOutline, eyeOutline, eyeOffOutline, arrowDownOutline,
        locationOutline});
}
